module.exports = __webpack_public_path__ + "img/holiday.8e5b765f.jpg";